import {IconProps} from 'types/IconProps'

const SwitchArrowsWithoutCircleIcon = ({height, width, color}: IconProps) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width || '24'}
      height={height || '24'}
      viewBox='0 0 24 24'
      fill='none'
    >
      <path
        d='M4.99182 12.9871C4.43954 12.9871 3.99182 13.4348 3.99182 13.9871C3.99182 14.3445 4.17931 14.6581 4.46129 14.8349L7.14891 17.5225C7.53943 17.9131 8.1726 17.9131 8.56312 17.5225C8.95365 17.132 8.95365 16.4988 8.56312 16.1083L7.4419 14.9871H14.9919C15.5441 14.9871 15.9919 14.5394 15.9919 13.9871C15.9919 13.4348 15.5441 12.9871 14.9919 12.9871H5.04127C5.03215 12.987 5.02303 12.987 5.01391 12.9871H4.99182Z'
        fill={color || '#666666'}
      />
      <path
        d='M19.0064 11.0185C19.5587 11.0185 20.0064 10.5708 20.0064 10.0185C20.0064 9.66113 19.819 9.34753 19.537 9.1707L16.8494 6.48308C16.4588 6.09256 15.8257 6.09256 15.4351 6.48308C15.0446 6.87361 15.0446 7.50677 15.4351 7.8973L16.5564 9.01852H9.00647C8.45418 9.01852 8.00647 9.46624 8.00647 10.0185C8.00647 10.5708 8.45418 11.0185 9.00647 11.0185H18.957C18.9661 11.0186 18.9752 11.0186 18.9844 11.0185H19.0064Z'
        fill={color || '#666666'}
      />
    </svg>
  )
}

export default SwitchArrowsWithoutCircleIcon
